import { useEffect } from 'react';
import { PRESENCE_HEARTBEAT_MS } from '../../constants';
import { markUserOffline, markUserOnline } from '../../services/presenceService';

const reportError = (error: unknown) =>
  console.error('Unable to update online status', error);

export const usePresence = (userId?: string) => {
  useEffect(() => {
    if (!userId) return undefined;

    const syncPresence = () => {
      const isActive = document.visibilityState === 'visible' && navigator.onLine;
      const operation = isActive ? markUserOnline(userId) : markUserOffline(userId);
      operation.catch(reportError);
    };

    const heartbeat = window.setInterval(syncPresence, PRESENCE_HEARTBEAT_MS);
    document.addEventListener('visibilitychange', syncPresence);
    window.addEventListener('online', syncPresence);
    window.addEventListener('offline', syncPresence);
    syncPresence();

    return () => {
      window.clearInterval(heartbeat);
      document.removeEventListener('visibilitychange', syncPresence);
      window.removeEventListener('online', syncPresence);
      window.removeEventListener('offline', syncPresence);
      markUserOffline(userId).catch(() => undefined);
    };
  }, [userId]);
};
